<script setup>
import FixPanel from "@/components/approval-center/partials/ui/FixPanel.vue";
import FixPanelHeaderTitle from "@/components/approval-center/partials/ui/FixPanelHeaderTitle.vue";
import FixPanelHeader from "@/components/approval-center/partials/ui/FixPanelHeader.vue";
import MoveGroupTransition from "@/components/transitions/MoveGroupTransition.vue";
import FixContent from "@/components/approval-center/partials/ui/FixContent.vue";
import FixPanelIcon from "@/components/approval-center/partials/ui/FixPanelIcon.vue";
import FixText from "@/components/approval-center/partials/ui/FixText.vue";
import useApprovalFlow from "@/composables/approval-center/useApprovalFlow";
import SuccessFlow from "@/components/approval-center/modals/SuccessFlow.vue";
import RevisionFlow from "@/components/approval-center/modals/RevisionFlow.vue";
import {useApprovals} from "@/composables/approval-center/useApprovals";
import LoadMoreButton from "@/components/approval-center/partials/buttons/LoadMoreButton.vue";
import useDates from "@/composables/useDates";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import FixPanelFooter from "@/components/approval-center/partials/ui/FixPanelFooter.vue";
import FixPanelSubText from "@/components/approval-center/partials/ui/FixPanelSubText.vue";

const props = defineProps({
  category: {
    type: String,
    required: true,
  },
});
const {
  showSuccessFlow,
  showRevisionFlow,
  handleConfirmMutation,
  handleConfirmRevisionMutation,
  handleClose,
  selectedApproval,
  selectApprovalForApprove,
  selectApprovalForRevision,
  revisionText,
} = useApprovalFlow();

const {mutate: handleConfirm} = handleConfirmMutation();
const {mutate: handleRevisionMutate, isPending: isRevisionPending} = handleConfirmRevisionMutation();

const {approvals, isPending} = useApprovals(props.category);
const {formattedDate} = useDates();
</script>

<template>
  <FixPanel v-if="approvals && approvals.length">
    <FixPanelHeader class="tw-flex-col !tw-items-start">
      <FixPanelHeaderTitle>Blog Titles</FixPanelHeaderTitle>
      <FixPanelSubText>Below are the blog post titles I’m proposing for the next 6 months, take a look and let me know if you’re happy with them.</FixPanelSubText>
    </FixPanelHeader>

    <LoadingBlock v-if="isPending" />

    <MoveGroupTransition
      v-else
      class="tw-space-y-8"
    >
      <FixPanel
        v-for="approval in approvals"
        :key="approval.id"
      >
        <FixPanelHeader>
          <FixPanelIcon icon-path="icons/calendar-2" />
          <FixPanelHeaderTitle>{{ formattedDate(approval?.approvable?.scheduled_date, 'MMMM') }}</FixPanelHeaderTitle>
        </FixPanelHeader>


        <div class="tw-flex tw-flex-col tw-gap-8">
          <FixContent>
            <FixText>
              <p class="tw-font-bold">
                {{ approval.approvable.title }}
              </p>
              <p>
                {{ approval.approvable.brief }}
              </p>
            </FixText>
          </FixContent>

          <FixPanelFooter
            :approval="approval"
            :category="category"
            @approve="selectApprovalForApprove(approval)"
            @revise="selectApprovalForRevision(approval)"
          />
        </div>
      </FixPanel>
    </MoveGroupTransition>

    <LoadMoreButton :category="category" />
  </FixPanel>

  <SuccessFlow
    v-if="showSuccessFlow"
    @confirm="handleConfirm({
      approval: selectedApproval,
      category: category,
    })"
    @close="handleClose"
  />

  <RevisionFlow
    v-if="showRevisionFlow"
    v-model:feedback="revisionText"
    :loading="isRevisionPending"
    @confirm="handleRevisionMutate({
      approval: selectedApproval,
      feedback: revisionText,
      category,
    })"
    @close="handleClose"
    @continue="handleClose"
  />
</template>
